import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050505]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo />
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#ff5a00] mb-4">Yhteystiedot</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-2"><MapPin size={16} className="text-[#ff5a00] mt-0.5" /> Äijälänkatu 3, 15700 Lahti</li>
            <li className="pt-2"><span className="font-mono text-[10px] uppercase tracking-widest text-white/40">Myyjä · Ville Paakkari</span></li>
            <li className="flex gap-2"><Phone size={16} className="text-[#ff5a00] mt-0.5" /> 044 354 9300</li>
            <li className="flex gap-2"><Mail size={16} className="text-[#ff5a00] mt-0.5" /> ville.paakkari@lahdenautokulma.fi</li>
            <li className="pt-2"><span className="font-mono text-[10px] uppercase tracking-widest text-white/40">Myyjä · Teijo Paakkari</span></li>
            <li className="flex gap-2"><Phone size={16} className="text-[#ff5a00] mt-0.5" /> 0500 653 999</li>
            <li className="flex gap-2"><Mail size={16} className="text-[#ff5a00] mt-0.5" /> teijo.paakkari@lahdenautokulma.fi</li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#ff5a00] mb-4">Aukioloajat</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex gap-2"><Clock size={16} className="text-[#ff5a00] mt-0.5" /> Ma–Pe 10–18</li>
            <li className="pl-6">La 10–14</li>
            <li className="pl-6">Su suljettu</li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-widest text-[#ff5a00] mb-4">Sivut</h4>
          <ul className="space-y-2 text-sm text-white/70">
            <li><Link to="/autot" className="hover:text-[#ff5a00] transition-colors">Autot</Link></li>
            <li><Link to="/rahoituslaskuri" className="hover:text-[#ff5a00] transition-colors">Rahoituslaskuri</Link></li>
            <li><Link to="/vaihtoauto" className="hover:text-[#ff5a00] transition-colors">Myy meille</Link></li>
            <li><Link to="/tiedotteet" className="hover:text-[#ff5a00] transition-colors">Tiedotteet</Link></li>
            <li><Link to="/login" className="hover:text-[#ff5a00] transition-colors">Ylläpito</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-6 md:px-12 flex flex-col gap-4">
        <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs font-mono uppercase tracking-widest">
          <Link to="/tietosuoja" className="text-white/50 hover:text-[#ff5a00] transition-colors">Tietosuojaseloste</Link>
          <Link to="/evasteet" className="text-white/50 hover:text-[#ff5a00] transition-colors">Evästekäytäntö</Link>
          <Link to="/kayttoehdot" className="text-white/50 hover:text-[#ff5a00] transition-colors">Käyttöehdot</Link>
          <Link to="/yritystiedot" className="text-white/50 hover:text-[#ff5a00] transition-colors">Yritystiedot</Link>
          <button onClick={() => window.Cookiebot?.renew?.()} data-testid="footer-cookie-settings"
            className="text-white/50 hover:text-[#ff5a00] transition-colors uppercase tracking-widest">Evästeasetukset</button>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-2 text-xs text-white/40 font-mono uppercase tracking-widest">
          <span>© {new Date().getFullYear()} Lahden Autokulma</span>
          <span>Laadukkaat vaihtoautot Lahdesta</span>
        </div>
      </div>
    </footer>
  );
}
